import { render, staticRenderFns } from "./TopPage.vue?vue&type=template&id=231944da&"
import script from "./TopPage.vue?vue&type=script&lang=js&"
export * from "./TopPage.vue?vue&type=script&lang=js&"
import style0 from "./TopPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports